import React, { lazy, Suspense } from 'react';
import './Acasa.css';
import helmetImg from '../../assets/halmet.png';
import service01 from '../../assets/service-01.png';
import service02 from '../../assets/service-02.png';
import service03 from '../../assets/service-03.png';
import { Slide } from "react-awesome-reveal";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Reviews = lazy(() => import('../Reviews/Reviews'));

function Acasa() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='acasa-div'>
      <div className='overlay' style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/images/home-banner.jpg)` }}>
        <div className='overlay-filter'>
          <Slide direction='up' triggerOnce='true' className='padding'>
            <div className='overlay-content'>
              <h1 className='overlay-title'>{t('company_name')}</h1>
              <p className='overlay-subtitle'>{t('overlay_subtitle')}</p>
              <p className='overlay-services'>{t('overlay_subtitle2')}</p>
              <p className='overlay-descriere'>{t('overlay_description')}</p>
              <button className='secondary-btn' onClick={()=>{navigate('/despre')}}>{t('learn_more')}</button>
            </div>
          </Slide>
        </div>
      </div>

      <div className='acasa-servicii'>
        <p>{t('responsibility_efficiency')}</p>
        <h2>{t('our_services')}</h2>
        <div className='lista-servicii padding'>
          <div className='card-servicii'>
            <img src={service01} alt="Servicii de arhitectură" className='blue-filter' width="60" height="60" loading="lazy" />
            <h2>{t('architecture')}</h2>
            <p>{t('architecture_description')}</p>
          </div>
          <div className='card-servicii'>
            <img src={service02} alt="Proiectare rezistență" className='blue-filter' width="60" height="60" loading="lazy" />
            <h2>{t('resistance')}</h2>
            <p>{t('resistance_description')}</p>
          </div>
          <div className='card-servicii'>
            <img src={service03} alt="Proiectare instalații" className='blue-filter' width="60" height="60" loading="lazy" />
            <h2>{t('installations')}</h2>
            <p>{t('installations_description')}</p>
          </div>
          <div className='card-servicii'>
            <img src={helmetImg} alt="Studii de specialitate" className='blue-filter' width="60" height="60" loading="lazy" />
            <h2>{t('specialized_studies')}</h2>
            <p>{t('specialized_studies_description')}</p>
          </div>
        </div>
        <button className='secondary-btn' onClick={()=>{navigate('/despre')}}>{t('learn_more_button')}</button>
      </div>

      <div className='portofoliu-div padding'>
        <p>{t('works')}</p>
        <h2>{t('completed_works')}</h2>
        <div className='portofoliu-poze'>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((num) => (
            <img
              key={num}
              src={`${process.env.PUBLIC_URL || ''}/images/portofoliu/img${num}.jpg`}
              alt={`Lucrare finalizată - proiect construcție ${num}`}
              className='img'
              width="400"
              height="350"
              loading="lazy"
            />
          ))}
        </div>
      </div>
      <Suspense fallback={<div className="reviews-loading"><div className="loading-spinner"></div></div>}>
        <Reviews />
      </Suspense>
      <div className='padding bg'>
        <p>{t('why_us')}</p>
        <h2>{t('our_team_quality_integrity')}</h2>
        <p>{t('have_project')}</p>
        <button className='secondary-btn' onClick={() => { navigate('/contact') }}>{t('contact_us')}</button>
      </div>
    </div>
  );
}

export default Acasa;